/* eslint-disable simple-import-sort/imports */
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import '../sentry.config';

import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import 'moment/dist/locale/pt-br';

import App from './App';
import reportWebVitals from './reportWebVitals';

moment.locale('pt-br');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
